<xilo-lib-dialog [xiloDialogConfig]="{
  header: {
    title: '',
    showClose: true,
    showBorder: false
  }
}"
>
<form class="xilo-dialog__form">
  <div class="xilo-dialog__body">
    <div class="flex justify-between">
      <span class="p-2"></span>
      <span class="mx-auto"><img class="w-6" src="assets/icons/warning.svg" alt="warning"></span>
      <span (click)="closeDialog()"><mat-icon class="text-xl">close</mat-icon></span>
    </div>
    <div class="flex flex-col gap-2">
      <span class="flex text-red-600 font-inter-regular text-sm text-center">
        {{ data.description }}
      </span>
    </div>
  </div>
</form>
</xilo-lib-dialog>